import classNames from 'classnames'

import { useVisibilityTrigger } from '../../../hooks'
import { readPost } from '../Newsboard.api'
import { isPostUnread } from '../Newsboard.utils'

import { NewsboardPostBody } from './NewsboardPostBody'
import { NewsboardPostFooter } from './NewsboardPostFooter'
import { NewsboardPostHeader } from './NewsboardPostHeader'

import * as styles from './NewsboardPost.module.css'

function NewsboardPost({
  disableReadTracking,
  fullWidth,
  loading,
  ref,
  value,
  onHideWelcomePost,
  onReload,
}) {
  const isUnreadPost = isPostUnread(value)

  function handleReadPost() {
    if (isUnreadPost && !disableReadTracking) {
      readPost(value.uuid)
    }
  }

  const { elementRef, viewed } = useVisibilityTrigger({
    callback: handleReadPost,
    options: {
      threshold: 1.0,
    },
  })

  const unread = !disableReadTracking && isUnreadPost && !viewed

  return (
    <div
      className={classNames(styles.NewsboardPost, {
        [styles.fullWidth]: fullWidth,
      })}
      ref={ref}
    >
      <NewsboardPostHeader
        data={value}
        loading={loading}
        unread={unread}
        onReload={onReload}
      />
      <NewsboardPostBody
        data={value}
        loading={loading}
        unread={unread}
        onReload={onReload}
      />
      <NewsboardPostFooter
        data={value}
        loading={loading}
        ref={elementRef}
        onHideWelcomePost={onHideWelcomePost}
      />
    </div>
  )
}

export default NewsboardPost
